function parsePriceNumber(priceWithCurrency: string): number {
  return !priceWithCurrency || /^[^0-9]$/.test(priceWithCurrency)
    ? 0
    : parseFloat(priceWithCurrency.replace(/[^0-9.-]+/g, ''));
}

export default parsePriceNumber;
